import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {passwordRequest} from "../../slice/changePasswordSlice";
import {USER_LOCALSTORAGE_KEY} from "../../../../shared/const/localstorage";
import {ChangePasswordFormValues} from "../../../../components/form/Form-change-password";
import {setChangePasswordError} from "../../slice/сhange-assword/changePassword";


export const fetchChangePassword = createAsyncThunk(
    'password/changePassword',
    async (requestData: ChangePasswordFormValues, thunkAPI) => {
        thunkAPI.dispatch(passwordRequest());
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);
            if (!token) {
                throw new Error('Invalid token format.');
            }
            const response = await axios.post('/api/profile/change-password', requestData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            thunkAPI.dispatch(setChangePasswordError(response.data));
            return response.data;
        } catch (error) {
            // Отправляем ошибку в payload
            // @ts-ignore
            throw new Error(error.message);
        }
    }
);
